export const recentChat = [
   {
      id: 1,
      active: true,
      userName: "Jason Oner",
      avatar: "/static/avatars/user-28.jpg"
   },
   {
      id: 2,
      active: true,
      userName: "Ranee Carlson",
      avatar: "/static/avatars/user-29.jpg"
   },
   {
      id: 3,
      userName: "Cindy Baker",
      avatar: "/static/avatars/user-30.jpg"
   },
   {
      id: 4,
      userName: "Ali Connors",
      avatar: "/static/avatars/user-31.jpg"
   },
   {
      id: 5,
      userName: "Harrison Hartman",
      avatar: "/static/avatars/user-35.jpg"
   }
]

export const previousChat = [
   {
      id: 5,
      userName: "Travis Howard",
      avatar: "/static/avatars/user-33.jpg"
   },
   {
      id: 6,
      userName: "Nicolette Conner",
      avatar: "/static/avatars/user-32.jpg"
   },
   {
      id: 7,
      userName: "Brock Marshall",
      avatar: "/static/avatars/user-34.jpg"
   }
]